import { render, staticRenderFns } from "./expertExitReview.vue?vue&type=template&id=71d3f9ba&scoped=true&"
import script from "./expertExitReview.vue?vue&type=script&lang=js&"
export * from "./expertExitReview.vue?vue&type=script&lang=js&"
import style0 from "./expertExitReview.vue?vue&type=style&index=0&id=71d3f9ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d3f9ba",
  null
  
)

export default component.exports